"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _reflux = _interopRequireDefault(require("reflux"));

var _QuizGameHighScore = _interopRequireDefault(require("../jsonSchemas/QuizGameHighScore.json"));

var _DataObjectValidator = require("../../../../helpers/DataObjectValidator");

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _QuizService = require("./QuizService");

var _QuizActions = _interopRequireDefault(require("../actions/QuizActions"));

// noinspection Eslint
// eslint-disable-line
var defaultGameHighscore = {
  type: 'QuizGameHighscore',
  value: {
    quiz: 'OmXxLNBARu2N7orYhP7dwA',
    emsId: 'OmXxLNBARu2N7orYhP7dwASCORE',
    highscore: []
  }
};
var defaultLevelHighscores = [{
  type: 'QuizLevelHighscore',
  playedRounds: 0,
  value: {
    level: 'foobar__-8iSievjRISVXibD2f67KQ',
    emsId: '-8iSievjRISVXibD2f67KQSCORE',
    highscore: []
  }
}];

var HighscoreService = _reflux["default"].createStore({
  state: {},
  // only for init store
  gameHighscore: null,
  levelHighscores: [],
  USER: null,
  listenables: _QuizActions["default"],
  sortLevelHighscore: function sortLevelHighscore() {
    this.levelHighscores.forEach(function (levelScore) {
      levelScore.value.highscore.sort(function (a, b) {
        if (a.points === b.points) {
          return 0;
        }

        if (a.points > b.points) {
          return -1;
        }

        return 1;
      });
      var rank = 0;
      var lastPoints = null;
      var ranksToSkip = 0;
      levelScore.value.highscore.forEach(function (score) {
        if (score.points === null || score.rank === null) {
          throw new Error('something expected is not defined');
        }

        if (score.points !== lastPoints) {
          rank += 1 + ranksToSkip;
          ranksToSkip = 0;
        } else {
          ranksToSkip += 1;
        } // noinspection Eslint (reason: directly modifying the parent object)


        score.rank = rank; // eslint-disable-line

        lastPoints = score.points;
      });
    });
  },
  sortGameHighscore: function sortGameHighscore() {
    this.gameHighscore.value.highscore.sort(function (a, b) {
      if (a.credits === b.credits) {
        return 0;
      }

      if (a.credits > b.credits) {
        return -1;
      }

      return 1;
    });
    var rank = 0;
    var lastPoints = null;
    var ranksToSkip = 0;
    this.gameHighscore.value.highscore.forEach(function (score) {
      if (score.rank === null || score.credits === null) {
        throw new Error('something expected is not defined');
      }

      if (score.credits !== lastPoints) {
        rank += 1 + ranksToSkip;
        ranksToSkip = 0;
      } else {
        ranksToSkip += 1;
      } // noinspection Eslint (reason: directly modifying the parent object)


      score.rank = rank; // eslint-disable-line

      lastPoints = score.credits;
    });
  },
  preloadGameHighscore: function preloadGameHighscore() {
    var _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var loadedHighscore;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _QuizService.getGameHighscore)();

            case 3:
              loadedHighscore = _context.sent;
              (0, _DataObjectValidator.validateDataObject)(loadedHighscore, _QuizGameHighScore["default"]);
              console.log('successfully got game highscore: ', loadedHighscore);
              _this.gameHighscore = loadedHighscore;

              _this.sortGameHighscore();

              console.log(_this.gameHighscore.value);

              _QuizActions["default"].setGameHighscores(_this.gameHighscore.value);

              return _context.abrupt("return", _promise["default"].resolve(_this.gameHighscore.value));

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.log('error loading game highscore', _context.t0);
              _this.gameHighscore = defaultGameHighscore;
              return _context.abrupt("return", _promise["default"].resolve(_this.gameHighscore.value));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }))();
  },
  preloadLevelHighscores: function preloadLevelHighscores() {
    var _this2 = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var loadedHighscores, parsedLoadedHighscores, i, highscore, isPresent;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _QuizService.getLevelHighscores)();

            case 3:
              loadedHighscores = _context2.sent;
              parsedLoadedHighscores = JSON.parse((0, _stringify["default"])(loadedHighscores)); // loadedHighscores = JSON.parse(JSON.stringify(loadedHighscores));

              console.log('successfully got level highscores: ', parsedLoadedHighscores);

              for (i = 0; i < parsedLoadedHighscores.length; i++) {
                highscore = parsedLoadedHighscores[i];
                isPresent = false;
                highscore.value.highscore.some(function (player) {
                  if (!player.username) {
                    throw new Error('something expected is not defined');
                  }

                  if (player.username === _this2.USER.userName) {
                    isPresent = true;
                    return true;
                  }

                  return false;
                });

                if (!isPresent) {
                  highscore.value.highscore.push({
                    name: _this2.OTHER.name,
                    points: 0,
                    username: _this2.OTHER.userName
                  });
                }
              }

              _this2.levelHighscores = parsedLoadedHighscores;

              _this2.sortLevelHighscore();

              _QuizActions["default"].setLevelHighscores(_this2.levelHighscores);

              return _context2.abrupt("return", _promise["default"].resolve(_this2.levelHighscores));

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);
              console.log('error loading level highscore', _context2.t0);

              if (!(_this2.levelHighscores === defaultLevelHighscores)) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return", _promise["default"].resolve(_this2.levelHighscores));

            case 18:
              (0, _values["default"])(_this2.levelHighscores).forEach(function (highscore) {
                if (!highscore.value) {
                  throw new Error('something expected is not defined');
                }

                highscore.value.highscore.push({
                  name: _this2.OTHER.name,
                  points: 0,
                  username: _this2.OTHER.userName
                });
              });
              return _context2.abrupt("return", _promise["default"].resolve(_this2.levelHighscores));

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 13]]);
    }))();
  },
  getGameHighscore: function getGameHighscore() {
    return this.gameHighscore.value.highscore;
  },
  getGameHighscoreHistory: function getGameHighscoreHistory() {
    return this.gameHighscore.value.history;
  },
  hasGameHighscore: function hasGameHighscore() {
    return this.gameHighscore !== defaultGameHighscore;
  },
  getLevelHighscore: function getLevelHighscore(levelId) {
    var foundHighscore = null;
    this.levelHighscores.some(function (highscore) {
      if (!highscore.value) {
        throw new Error('something expected is not defined');
      }

      if (highscore.value.level === levelId) {
        foundHighscore = highscore.value.highscore;
        return true;
      }

      return false;
    });

    if (foundHighscore) {
      return foundHighscore;
    }

    this.levelHighscores[levelId] = {
      type: 'QuizLevelHighscore',
      playedRounds: 0,
      value: {
        highscore: [{
          name: this.OTHER.name,
          points: 0,
          username: this.OTHER.userName
        }],
        level: levelId,
        emsId: "".concat(levelId, "SCORE")
      }
    };
    return this.levelHighscores[levelId].value.highscore;
  },
  getPlayerPoints: function getPlayerPoints(levelId) {
    var levelHighScore = this.getLevelHighscore(levelId);

    if (levelHighScore != null) {
      for (var i = 0; i < levelHighScore.length; i += 1) {
        if (levelHighScore[i].username && levelHighScore[i].username === this.USER.userName) {
          return typeof levelHighScore[i].points !== 'undefined' ? levelHighScore[i].points : 0;
        }
      }
    }

    return 0;
  },
  getPlayedRoundsInLevel: function getPlayedRoundsInLevel(levelId) {
    var playedRounds = 0; // for (const highscore of this.levelHighscores) {

    this.levelHighscores.forEach(function (highscore) {
      if (highscore.value.level === levelId) {
        playedRounds = highscore.value.playedRounds;
      }
    });
    return playedRounds;
  },
  onSetUser: function onSetUser(message) {
    if (message.user == null) {
      return;
    }

    this.USER = message.user;
  },
  onAddLevelPoints: function onAddLevelPoints(message) {
    var _this3 = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var levelId, points, levelHighscore, resultPoints;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              levelId = message.levelId;
              points = message.points;
              _context3.prev = 2;
              _context3.next = 5;
              return _this3.preloadLevelHighscores();

            case 5:
              levelHighscore = null;
              (0, _values["default"])(_this3.levelHighscores).forEach(function (highscore) {
                if (highscore.value.level === levelId) {
                  levelHighscore = highscore;
                }
              });

              if (!(levelHighscore === null)) {
                _context3.next = 10;
                break;
              }

              (0, _AlertHelper.showAlertWithOptions)({
                message: 'Punktzahl konnte nicht gespeichert werden.'
              }); // showAlert('Punktzahl konnte nicht gespeichert werden.')
              // TODO: find out if we can use reject(new Error(message)) here

              return _context3.abrupt("return", _promise["default"].reject('Punktzahl konnte nicht gespeichert werden.'));

            case 10:
              resultPoints = null;
              levelHighscore.value.highscore.forEach(function (player) {
                if (player.username === _this3.USER.userName) {
                  var playerPoints = player.points;
                  playerPoints += points;
                  resultPoints = playerPoints;
                }
              });
              _this3.levelHighscores = [levelHighscore];

              _this3.sortLevelHighscore();

              if (resultPoints != null) {
                _QuizActions["default"].updateScores({
                  levelId: levelId,
                  levelPoints: resultPoints,
                  currentLevelHighscores: _this3.levelHighscores[0].value.highscore
                }); // this.trigger({levelPoints: resultPoints}); // inform all Listeners about the levelPoints

              }

              levelHighscore.value.playedRounds += 1;
              (0, _QuizService.replaceLevelHighscoreList)(levelHighscore);
              return _context3.abrupt("return", _promise["default"].resolve());

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](2);
              console.log(_context3.t0);
              return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 20]]);
    }))();
  }
});

var _default = HighscoreService;
exports["default"] = _default;